/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
export * from "./PassportUserManagementServiceClientConfigFactory";
